import { CLIENT_PORTAL_ERROR } from "./clientPortalConstants";

const SAFE_MESSAGES = Object.freeze({
  [CLIENT_PORTAL_ERROR.invalidLogin]:
    "Sign-in failed. Check your details or try again later.",
  [CLIENT_PORTAL_ERROR.sessionExpired]:
    "Your session has expired. Sign in again to continue.",
  [CLIENT_PORTAL_ERROR.accountUnavailable]:
    "This account is not available in the client portal.",
  [CLIENT_PORTAL_ERROR.temporarilyUnavailable]:
    "This section is temporarily unavailable. Please try again.",
  [CLIENT_PORTAL_ERROR.promotionAlreadyClaimed]:
    "This promotion has already been claimed.",
  [CLIENT_PORTAL_ERROR.promotionClaimPending]:
    "This promotion claim is pending.",
  [CLIENT_PORTAL_ERROR.promotionFrequencyLimited]:
    "You have reached this promotion's claim limit.",
  [CLIENT_PORTAL_ERROR.accountValidationRequired]:
    "Validate your account before claiming promotions.",
  [CLIENT_PORTAL_ERROR.promotionUnavailable]:
    "This promotion cannot be claimed right now.",
  [CLIENT_PORTAL_ERROR.checkoutValidation]:
    "The order could not be validated. Review it and try again.",
  [CLIENT_PORTAL_ERROR.paymentPending]:
    "Payment is still pending. Check again shortly.",
  [CLIENT_PORTAL_ERROR.paymentFailed]:
    "Payment could not be completed. You can try the same order again.",
  [CLIENT_PORTAL_ERROR.unknown]:
    "Something went wrong. Please try again.",
});

export class ClientPortalHttpError extends Error {
  constructor(status, data = null) {
    super("Client portal request failed");
    this.name = "ClientPortalHttpError";
    this.status = Number(status) || 0;
    this.code = String(
      data && typeof data === "object" ? data.code || "" : ""
    );
  }
}

export function getClientPortalErrorCategory(error, fallback = CLIENT_PORTAL_ERROR.unknown) {
  if (error?.status === 401) return CLIENT_PORTAL_ERROR.sessionExpired;
  if (error?.category && SAFE_MESSAGES[error.category]) return error.category;
  if (error?.status >= 500 || error?.status === 0) {
    return CLIENT_PORTAL_ERROR.temporarilyUnavailable;
  }
  if (error?.code === "PRMT-020") return CLIENT_PORTAL_ERROR.promotionAlreadyClaimed;
  if (error?.code === "PRMT-021") return CLIENT_PORTAL_ERROR.promotionClaimPending;
  if (error?.code === "PRMT-022") return CLIENT_PORTAL_ERROR.promotionFrequencyLimited;
  if (error?.code === "PRMT-050") return CLIENT_PORTAL_ERROR.accountValidationRequired;
  if (error?.code === "PRMT-060") return CLIENT_PORTAL_ERROR.accountUnavailable;
  if (
    error?.code === "PRMT-040" ||
    error?.code === "PRMT-070" ||
    error?.status === 403
  ) {
    return CLIENT_PORTAL_ERROR.promotionUnavailable;
  }
  return fallback;
}

export function normalizeClientPortalError(error, fallback = CLIENT_PORTAL_ERROR.unknown) {
  const category = getClientPortalErrorCategory(error, fallback);
  return {
    category,
    message: SAFE_MESSAGES[category] || SAFE_MESSAGES[CLIENT_PORTAL_ERROR.unknown],
    retryable:
      category === CLIENT_PORTAL_ERROR.temporarilyUnavailable ||
      category === CLIENT_PORTAL_ERROR.paymentPending ||
      category === CLIENT_PORTAL_ERROR.paymentFailed,
  };
}

export function safeClientPortalMessage(category) {
  return SAFE_MESSAGES[category] || SAFE_MESSAGES[CLIENT_PORTAL_ERROR.unknown];
}
